let API_URL = 'http://localhost:3000';

export function configureApi(baseUrl: string) {
    API_URL = baseUrl;
}

export interface RequestOptions {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    body?: unknown;
    token?: string;
}

async function request<T>(path: string, options: RequestOptions = {}): Promise<T> {
    const { method = 'GET', body, token } = options;

    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
    });

    if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    if (response.status === 204 || response.headers.get('content-length') === '0') {
        return undefined as T;
    }

    const text = await response.text();
    return text ? JSON.parse(text) : (undefined as T);
}

export const api = {
    get: <T>(path: string, token?: string) => request<T>(path, { token }),
    post: <T>(path: string, body: unknown, token?: string) => request<T>(path, { method: 'POST', body, token }),
    put: <T>(path: string, body: unknown, token?: string) => request<T>(path, { method: 'PUT', body, token }),
    delete: <T>(path: string, token?: string) => request<T>(path, { method: 'DELETE', token }),
};
